export default "__VITE_ASSET__56dd1975__"